import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IDRY_Report } from '../../interface/common/dry_report';
import { environment } from '../../../environments/environment';
import { employeedetailsdirectreports } from '../../interface/delegationofauthority/employeedetails';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getAvailableColumnTableInReportCol(
    searchTableName: string
  ): Observable<string> {
    const url = `${this.baseUrl}DelegationOfAuthority/GetAvailableColumnTableInReportCol?tableName=${searchTableName}`;
    return this.http.get(url, { responseType: 'text' });
  }

  getAvailableColumnNamesVWTable(searchTableName: string): Observable<string> {
    const url = `${this.baseUrl}DelegationOfAuthority/GetAvailableColumnNamesVW?tableName=${searchTableName}`;
    return this.http.get(url, { responseType: 'text' });
  }

  public updateNewReport(obj: IDRY_Report): Observable<any> {
    return this.http.post(
      `${this.baseUrl}DelegationOfAuthority/DefineNewReport`,
      obj
    );
  }

  getEmployeeDetails(
    empNoCaiOrUserId: string
  ): Observable<employeedetailsdirectreports> {
    const url = `${this.baseUrl}/DelegationOfAuthority/GetEmployeeInformations?empNoCaiOrUserId=${empNoCaiOrUserId}`;
    return this.http.get<employeedetailsdirectreports>(url);
  }

  getAvailableColumn(): Observable<string> {
      return this.http.get<string>(`${this.baseUrl}/DelegationOfAuthority/GetAvailableColumnTable`);
    }
}
